

const app = {
  state: {
    seachParams: {
      classTypeCode: '',
      periodCode: '',
      stageCode: '',
      productCode: '',
      schoolId: '',
      classId: '',
      subjectCode: '',
      
      publicTimeStart: '',
      publicTimeEnd: '',
    },
    publicTime: []
  },
  mutations: {
    UPDATED_SEACHPARAMS: (state, seachParams) => {
      state.seachParams = {...state.seachParams, ...seachParams}
    },
    UPDATED_PUBLICETIME: (state, publicTime) => {
      state.publicTime = publicTime
    },

  },
  actions: {
    updateSeachParams: ({commit}, data) => {

      commit('UPDATED_SEACHPARAMS', data)
    },
    updatePublishTime: ({commit}, data) => {

      commit('UPDATED_PUBLICETIME', data)
    }
  }
}

export default app
